(function() {
  if (!('IntersectionObserver' in window)) return;
  if (window.innerWidth > 768) return; // desktop only uses hover

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      var card = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        card.classList.add('pf-col-card--in-view');
      } else {
        card.classList.remove('pf-col-card--in-view');
      }
    });
  }, {
    threshold: [0, 0.5, 1.0],
    rootMargin: '0px 0px -60px 0px'
  });

  function observeCards() {
    document.querySelectorAll('.pf-col-card').forEach(function(card) {
      card.classList.add('pf-fade-init');
      observer.observe(card);
    });
  }

  // Initial run
  observeCards();

  // Re-run after load-more fetch swaps new cards in
  document.addEventListener('pf:grid-updated', observeCards);

})();